import {DateMask} from "./DateMask";

export class Datepicker {

    static init() {
        var $ = jQuery;
        var selector = $('.js-datepicker');

        selector.each(function (index, input) {
            input.classList.remove('moved-input');

            var dateMask = new DateMask(input, {
                htmlInputClass: 'form-input moved-input js-datemask-html'
            });
        });

    }

}